// This icon file is generated automatically.
var PPushpinOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.72 4.13L7.87.28a.52.52 0 00-.73 0L4.62 2.8a5.15 5.15 0 00-3.8 1.1.52.52 0 00-.04.77L3.62 7.5.25 10.87a.25.25 0 00-.07.15l-.05.58c-.02.15.1.27.24.27H.4l.58-.05c.06 0 .11-.03.15-.07L4.5 8.38l2.84 2.84a.52.52 0 00.77-.04 5.16 5.16 0 001.1-3.8l2.51-2.52c.2-.2.2-.53 0-.73zM8.41 6.58l-.38.39.06.53a4.06 4.06 0 01-.48 2.4L2.1 4.4a3.98 3.98 0 012.4-.48l.55.06.38-.38L7.5 1.5l2.99 3-2.1 2.08z", "fill-rule": "nonzero" } }] }, "name": "p-pushpin", "theme": "outlined" };
export default PPushpinOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPushpinOutlined.js
// module id = 3556
// module chunks = 0